module.exports = __webpack_public_path__ + "static/media/downloadPrAndroid.b4b3072e.svg";